(function(root) {
define("bootstrap-prototype-fix", ["jquery"], function() {
  return (function() {
!(function($, window, undefined) {
	var affectedElements = [];

	$(document.body).on(
		"hide.bs.dropdown hide.bs.collapse hide.bs.modal hide.bs.tooltip hide.bs.popover show.bs.dropdown show.bs.collapse show.bs.modal show.bs.tooltip show.bs.popover",
		"*",
		function(e) {
			if (affectedElements.indexOf(e.target) < 0) {
				affectedElements.push(e.target);
			}
		}
	);

	var originalHide = Element.hide,
		originalShow = Element.show;

	Element.addMethods({
		hide: function(element) {
			var index = affectedElements.indexOf(element);

			if (index >= 0) {
				affectedElements.splice(index, 1);
				return element;
			}

			return originalHide(element);
		},

		show: function(element) {
			var index = affectedElements.indexOf(element);

			if (index >= 0) {
				affectedElements.splice(index, 1);
				return element;
			}

			return originalShow(element);
		}
	});
})(jQuery, this);

  }).apply(root, arguments);
});
}(this));

